<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group class="col-12 my-0 pb-0">
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
              @change="ativoMudado"
            >
              <label style="font-size: 1rem">Documento ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Descrição"
            class="col-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Descrição"
            >
              <b-form-input
                v-model="form.descricao"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-col cols="6">
            <departamento-select
              v-model="form.departamento"
              :require="true"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-form-group
            label="Periodicidade"
            class="col-3"
          >
            <b-select
              v-model="form.periodicidade"
              @change="verificaPeriodicidade"
            >
              <option
                v-for="(option, $index) in opcoesPeriodicidade"
                :key="$index"
                :value="option.value"
              >{{ option.text }}</option>
            </b-select>
          </b-form-group>
          <b-form-group
            label="Mês"
            class="col-3"
          >
            <validation-provider
              #default="{ errors }"
              :rules="{required: form.periodicidade === 4}"
              name="Mês"
            >
              <b-select
                v-model="form.mes"
                :disabled="form.periodicidade !== 4"
              >
                <option :value="null" />
                <option
                  v-for="(option, $index) in opcoesMes"
                  :key="$index"
                  :value="option.value"
                >{{ option.text }}</option>
              </b-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col
            v-if="form.periodicidade === 1"
            cols="6"
          >
            <legend
              tabindex="-1"
              class="bv-no-focus-ring col-form-label pt-0"
            >&nbsp;</legend>
            <b-form-checkbox
              v-model="form.competenciaAtual"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
            >
              Considerar competência atual
            </b-form-checkbox>
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>

import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import api from '@/app-modulo/documento/documento/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'Documento',
  components: {
    CadastroBase,
    ValidationProvider,
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
  },
  data() {
    return {
      required,
      form: {
        descricao: null,
        ativo: true,
        departamento: null,
        periodicidade: 0,
        mes: null,
        competenciaAtual: false,
      },
      opcoesPeriodicidade: [
        { value: 0, text: 'Não recorrente' },
        { value: 1, text: 'Mensal' },
        { value: 2, text: 'Trimestral' },
        { value: 3, text: 'Semestral' },
        { value: 4, text: 'Anual' },
      ],
      opcoesMes: [
        { value: 1, text: 'Janeiro' },
        { value: 2, text: 'Fevereiro' },
        { value: 3, text: 'Março' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Maio' },
        { value: 6, text: 'Junho' },
        { value: 7, text: 'Julho' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Setembro' },
        { value: 10, text: 'Outubro' },
        { value: 11, text: 'Novembro' },
        { value: 12, text: 'Dezembro' },
      ],
      immutableForm: {},
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getDocumento(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createDocumento(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Documento cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateDocumento(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Documento alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    verificaPeriodicidade() {
      if (this.form.periodicidade !== 4) {
        this.form.mes = null
      }
    },
    ativoMudado(value) {
      if (!value) {
        this.$swal({
          title: 'Atenção!',
          text: 'Essa ação inativará este documento e todos os seus vínculos com o cadastro '
          + 'de modelos, empresas e documentos customizados.\n'
          + 'Deseja continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (!result.value) {
            this.form.ativo = true
          }
        })
      }
    },
  },
}
</script>
